
import Button from '../../../components/base/Button';

export default function AnchorSection() {
  const services = [
    {
      title: '爆品库',
      subtitle: '精选优质茶品，一键选品系统',
      icon: 'ri-star-line',
      color: 'from-blue-500 to-blue-600',
      features: [
        '按品类智能筛选（收藏/口粮/调饮）',
        '价格带精准匹配',
        '场景化推荐系统',
        '实时库存更新'
      ]
    },
    {
      title: '内容支持',
      subtitle: '专业内容团队，全方位创作支持',
      icon: 'ri-video-line',
      color: 'from-slate-500 to-slate-600',
      features: [
        '短视频素材库（茶文化科普/产品展示）',
        '直播话术包（年份茶解析/山头茶话术）',
        '售后应答标准模板',
        '专业拍摄指导'
      ]
    },
    {
      title: '数据服务',
      subtitle: '实时数据分析，科学决策支持',
      icon: 'ri-bar-chart-line',
      color: 'from-blue-400 to-blue-500',
      features: [
        '实时销售看板',
        '热卖品类趋势分析',
        '用户画像精准分析',
        '竞品对比报告'
      ]
    }
  ];

  const cases = [
    {
      name: '茶香小姐姐',
      followers: '500万粉丝',
      gmv: '月GMV 2000万+',
      specialty: '专注高端收藏茶',
      avatar: 'https://public.readdy.ai/ai/img_res/c9a6c9e1cb82f9fa124063ced9143d5b.jpg'
    },
    {
      name: '老铁说茶',
      followers: '300万粉丝',
      gmv: '月GMV 1500万+',
      specialty: '口粮茶性价比之王',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20tea%20expert%20in%20casual%20but%20refined%20clothing%2C%20tasting%20tea%20in%20modern%20tea%20studio%2C%20professional%20tea%20tasting%20setup%2C%20confident%20expression%2C%20live%20streaming%20environment%2C%20warm%20lighting%2C%20authentic%20tea%20culture%20atmosphere&width=400&height=400&seq=anchor2&orientation=squarish'
    },
    {
      title: '更多合作案例',
      description: '200+ 头部主播的共同选择',
      icon: 'ri-add-line'
    }
  ];

  return (
    <section id="anchor" className="py-20 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="container mx-auto px-6 lg:px-16 xl:px-24">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            让带货更简单，让信任更简单
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            为主播提供一站式供应链解决方案，从选品到售后，全程专业支持
          </p>
        </div>

        {/* Services */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 hover:transform hover:scale-105"
            >
              <div className={`w-16 h-16 mb-6 rounded-2xl bg-gradient-to-r ${service.color} flex items-center justify-center`}>
                <i className={`${service.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2">{service.title}</h3>
              <p className="text-sm md:text-base text-blue-600 font-medium mb-6">{service.subtitle}</p>
              <div className="space-y-3">
                {service.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                    <span className="text-gray-600 text-xs md:text-sm leading-relaxed">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Success Cases */}
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-8 text-center">
            头部主播合作案例
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {cases.map((case_, index) => (
              <div key={index} className="text-center">
                {case_.avatar ? (
                  <>
                    <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden shadow-lg">
                      <img
                        src={case_.avatar}
                        alt={case_.name}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <h4 className="text-base md:text-lg font-bold text-gray-800 mb-2">{case_.name}</h4>
                    <div className="space-y-1 text-xs md:text-sm text-gray-600">
                      <p>{case_.followers}</p>
                      <p className="text-blue-600 font-medium">{case_.gmv}</p>
                      <p>{case_.specialty}</p>
                    </div>
                  </>
                ) : (
                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 hover:border-blue-500 transition-colors duration-300">
                    <div className="w-16 h-16 mx-auto mb-4 bg-gray-200 rounded-full flex items-center justify-center">
                      <i className={`${case_.icon} text-gray-500 text-2xl`}></i>
                    </div>
                    <h4 className="text-base md:text-lg font-bold text-gray-800 mb-2">{case_.title}</h4>
                    <p className="text-sm md:text-base text-gray-600">{case_.description}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
          
          <div className="text-center mt-8">
            <a href="/cooperation">
              <Button variant="primary" size="lg">
                立即申请合作
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
